import { useContext, useEffect, useState } from "react";
import "./index.less"
import FileManager from "@/panel/pm/file-manager";
import SystemLog from "@/panel/pm/system-log";
import Column from "@/panel/archibase/column";
import RoofSlab from "@/panel/archibase/roof-slab";
import EavesBoardPanel from "@/panel/archibase/eaves-board";
import Gutter from "@/panel/archibase/gutter";
import MonitoringParams from "@/panel/lib/monitoring-params";
import ConsititutiveRelationship from "@/panel/lib/consititutive-relationship";
import Device from "@/panel/lib/device";
import ComputingMethod from "@/panel/lib/computing-method";
import { SideStatus } from "@/global/store/side-store";
import { SideContext } from "@/App";
import StationPanel from "../../../panel/archibase/station";
import DataBoxPanel from "@/panel/device/collection-device";
import SensorContainer from "@/panel/device/sensor";
import { SENSOR_TYPE } from "@/enums/sensor-type";
import { DATA_BOX_TYPE } from "@/enums/data-box-type";
import DeviceListPanel from "@/panel/device/device-list";
import CablePanel from "@/panel/device/cable";
import MonitorObjectPanel from "@/panel/monitor/monitor-object";
import MonitorParameterPanel from "@/panel/monitor/monitor-parameter";
import ParamMatchSensor from "@/panel/monitor/param-match-sensor";
import ComponentPanel from "@/panel/archibase/component";
import TestRecordSide from "@/panel/install-test/test-record-panel";
import UserManagerPanel from "@/panel/pm/user-manager";

export default function SidePanel() {
    const [sidePath, setSidePath] = useState<string>("")
    const sideContext = useContext<SideStatus>(SideContext);

    // 根据侧边栏全局变量控制侧边栏显示页面
    useEffect(() => {
        setSidePath(sideContext.selectedPanel);
    }, [sideContext.selectedPanel]);

    return (
        <div className="side-panel">
            {/* 监测对象 */}
            {(!sidePath || sidePath == "" || sidePath == "monitor-object") && <MonitorObjectPanel />}
            {/* 监测参数 */}
            {sidePath == "monitor-parameter" && <MonitorParameterPanel />}
            {/* 文件管理 */}
            {sidePath == "file-manager" && <FileManager />}
            {/* 系统日志 */}
            {sidePath == "system-log" && <SystemLog />}
            {/* 用户管理 */}
            {sidePath == "user-manager" && <UserManagerPanel />}
            {/* 站台 */}
            {sidePath == "station" && <StationPanel />}
            {/* 柱 */}
            {sidePath == "column" && <Column />}
            {/* 屋面板 */}
            {sidePath == "roof-slab" && <RoofSlab />}
            {/* 檐口板 */}
            {sidePath == "eaves-board" && <EavesBoardPanel />}
            {/* 天沟 */}
            {sidePath == "gutter" && <Gutter />}
            {/* 设备列表 */}
            {sidePath == "device-list" && <DeviceListPanel />}
            {/* 摄像头 */}
            {sidePath == "camera" && <SensorContainer sensorType={SENSOR_TYPE.CAMERA} />}
            {/* 水位计 */}
            {sidePath == "water-level-gauge" && <SensorContainer sensorType={SENSOR_TYPE.FLUVIOGRAPH} />}
            {/* 风速风向仪 */}
            {sidePath == "anemoclinograph" && <SensorContainer sensorType={SENSOR_TYPE.ANEMOCLINOGRAPH} />}
            {/* 串口设备 */}
            {sidePath == "serial-device" && <DataBoxPanel dataBoxType={DATA_BOX_TYPE.SERIAL} />}
            {/* 硬盘录像机 */}
            {sidePath == "dvr" && <DataBoxPanel dataBoxType={DATA_BOX_TYPE.DVR} />}
            {/* 工控机 */}
            {sidePath == "IPC-list" && <DataBoxPanel dataBoxType={DATA_BOX_TYPE.IPC} />}
            {/* 设备 */}
            {sidePath == "device" && <Device />}
            {/* 计算方法 */}
            {sidePath == "computing-method" && <ComputingMethod />}
            {/* 监测参数 */}
            {sidePath == "monitoring-params" && <MonitoringParams />}
            {/* 本构关系 */}
            {sidePath == "consititutive-relationship" && <ConsititutiveRelationship />}
            {/* 数据线缆 */}
            {sidePath == "cable" && <CablePanel />}
            {/* 传感器匹配 */}
            {sidePath == "param-match-sensor" && <ParamMatchSensor />}

            {/* 测试记录 */}
            {sidePath == "test-record" && <TestRecordSide />}

            {/* 建模组件 */}
            {sidePath == "component" && <ComponentPanel />}
        </div>
    )
}